(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const money = (cents, currency) => {
    const whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(whole ? 0 : 2);
    }
  };

  const showDeferred = (scope) => {
    scope.querySelectorAll('img[data-rc-src]').forEach((img) => {
      if (img.dataset.rcSrcset) img.srcset = img.dataset.rcSrcset;
      img.src = img.dataset.rcSrc;
      img.removeAttribute('data-rc-src');
      img.removeAttribute('data-rc-srcset');
    });
  };

  document.querySelectorAll('[data-rc-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-rc-track]');
    if (!track) return;
    const reveal = () => showDeferred(gallery);
    ['scroll', 'pointerdown', 'touchstart', 'focusin'].forEach((type) => track.addEventListener(type, reveal, { once: true, passive: true }));
    gallery.querySelectorAll('[data-rc-thumb]').forEach((thumb) => thumb.addEventListener('click', reveal, { once: true }));
    const later = () => setTimeout(reveal, 1200);
    if (document.readyState === 'complete') later();
    else window.addEventListener('load', later, { once: true });
    const slides = Array.from(track.children);
    const count = gallery.querySelector('[data-rc-count]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-rc-thumb]'));
    const show = (index) => {
      if (count) count.textContent = index + 1 + ' / ' + slides.length;
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', i === index ? 'true' : 'false'));
    };
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) show(slides.indexOf(entry.target));
        });
      },
      { root: track, threshold: 0.6 }
    );
    slides.forEach((slide) => observer.observe(slide));
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      });
    });
  });

  document.querySelectorAll('[data-rc-video-open]').forEach((button) => {
    const dialog = document.getElementById(button.getAttribute('aria-controls'));
    if (!dialog) return;
    const video = dialog.querySelector('video');
    button.addEventListener('click', () => {
      dialog.showModal();
      if (video) video.play().catch(() => {});
    });
    dialog.addEventListener('close', () => {
      if (video) video.pause();
    });
    dialog.querySelectorAll('[data-rc-close]').forEach((close) => close.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  document.querySelectorAll('[data-rc-eta]').forEach((el) => {
    const min = parseInt(el.dataset.min, 10);
    const max = parseInt(el.dataset.max, 10);
    const out = el.querySelector('[data-rc-eta-text]');
    if (!out || isNaN(min) || isNaN(max)) return;
    const day = 24 * 60 * 60 * 1000;
    const now = new Date();
    const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    out.textContent = 'arrives ' + fmt(new Date(now.getTime() + min * day)) + ' – ' + fmt(new Date(now.getTime() + max * day));
  });

  document.querySelectorAll('[data-rc-buy]').forEach((box) => {
    const form = box.querySelector('form');
    const button = box.querySelector('[data-rc-submit]');
    const addon = box.querySelector('[data-rc-addon]');
    const error = box.querySelector('[data-rc-error]');
    const currency = box.dataset.currency;
    const totals = document.querySelectorAll('[data-rc-total="' + box.dataset.section + '"]');
    const sticky = document.querySelector('[data-rc-sticky="' + box.dataset.section + '"]');
    if (!form || !button) return;

    const variantInput = () => form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');

    const update = () => {
      const variant = variantInput();
      let cents = variant ? parseInt(variant.dataset.price, 10) || 0 : 0;
      if (addon && addon.checked) cents += parseInt(addon.dataset.price, 10) || 0;
      const label = money(cents, currency);
      totals.forEach((el) => {
        el.textContent = label;
      });
    };

    form.addEventListener('change', update);
    update();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const variant = variantInput();
      if (!variant) return;
      const items = [{ id: parseInt(variant.value, 10), quantity: 1 }];
      if (addon && addon.checked) items.push({ id: parseInt(addon.value, 10), quantity: 1 });
      button.setAttribute('aria-busy', 'true');
      if (error) error.hidden = true;
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
        }
        window.location.href = root + (box.dataset.after === 'cart' ? 'cart' : 'checkout');
      } catch (err) {
        button.removeAttribute('aria-busy');
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
      }
    });

    if (sticky) {
      const stickyButton = sticky.querySelector('[data-rc-sticky-submit]');
      if (stickyButton) stickyButton.addEventListener('click', () => form.requestSubmit());
      const observer = new IntersectionObserver(
        ([entry]) => {
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', passed);
          sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
          if (stickyButton) stickyButton.tabIndex = passed ? 0 : -1;
        },
        { threshold: 0 }
      );
      observer.observe(button);
    }
  });

  document.querySelectorAll('[data-rc-countdown]').forEach((el) => {
    const end = Date.parse(el.dataset.end);
    const out = el.querySelector('[data-rc-countdown-time]');
    const wrap = el.closest('[data-rc-offer]') || el;
    if (isNaN(end) || !out) {
      wrap.hidden = true;
      return;
    }
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) {
        wrap.hidden = true;
        return false;
      }
      const d = Math.floor(left / 864e5);
      const h = Math.floor(left / 36e5) % 24;
      const m = Math.floor(left / 6e4) % 60;
      const s = Math.floor(left / 1e3) % 60;
      out.textContent = d ? d + 'd ' + h + 'h' : pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      return true;
    };
    if (tick()) {
      const timer = setInterval(() => {
        if (!tick()) clearInterval(timer);
      }, 1000);
    }
  });

  document.querySelectorAll('[data-rc-pop]').forEach((pop) => {
    const key = 'rc-pop-seen';
    const posted = /customer_posted=true/.test(window.location.search);
    let seen = false;
    try {
      seen = window.localStorage.getItem(key) === '1';
    } catch (e) {}
    const open = () => {
      if (!pop.hidden) return;
      pop.hidden = false;
      requestAnimationFrame(() => pop.classList.add('is-open'));
      try {
        window.localStorage.setItem(key, '1');
      } catch (e) {}
    };
    const close = () => {
      pop.classList.remove('is-open');
      setTimeout(() => {
        pop.hidden = true;
      }, 250);
    };
    pop.querySelectorAll('[data-rc-pop-close]').forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !pop.hidden) close();
    });
    if (posted) {
      open();
      return;
    }
    if (seen) return;
    setTimeout(open, (parseInt(pop.dataset.delay, 10) || 8) * 1000);
  });

  const loadImage = (img) => {
    if (!img.dataset.rcSrc) return;
    if (img.dataset.rcSrcset) img.srcset = img.dataset.rcSrcset;
    img.src = img.dataset.rcSrc;
    img.removeAttribute('data-rc-src');
    img.removeAttribute('data-rc-srcset');
  };

  if ('IntersectionObserver' in window) {
    const near = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadImage(entry.target);
          near.unobserve(entry.target);
        });
      },
      { rootMargin: '400px 300px' }
    );
    document.querySelectorAll('img[data-rc-src]').forEach((img) => {
      if (!img.closest('[data-rc-track]')) near.observe(img);
    });

    const offerTap = (video) => {
      const holder = video.parentElement;
      if (!holder || holder.querySelector('.rc-tap-play')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rc-tap-play';
      button.setAttribute('aria-label', 'Play video');
      button.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>';
      button.addEventListener('click', () => {
        video.muted = true;
        video.play().then(() => {
          video.classList.add('is-playing');
          button.remove();
        }).catch(() => {});
      });
      holder.appendChild(button);
    };

    const videos = document.querySelectorAll('video[data-rc-video]');
    const watcher = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (!video.src) video.src = video.dataset.rcVideo;
            video.muted = true;
            video.play().then(() => video.classList.add('is-playing')).catch(() => offerTap(video));
          } else if (video.src) {
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );
    videos.forEach((video) => watcher.observe(video));
  } else {
    document.querySelectorAll('img[data-rc-src]').forEach(loadImage);
  }
})();
